import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";

export default function Toggler({ darkMode, handleClick }) {
    return (
        <Tooltip title={darkMode ? "Switch to Light Mode" : "Switch to Dark Mode"}>
            <IconButton
                onClick={handleClick}
                size="small"
                sx={{
                    color: "inherit",
                    border: "1px solid",
                    borderColor: "divider",
                    borderRadius: "8px",
                    p: 0.6,
                    ml: { xs: 1, sm: 2 }
                }}
            >
                {darkMode ? <LightModeOutlinedIcon fontSize="small" /> : <DarkModeOutlinedIcon fontSize="small" />}
            </IconButton>
        </Tooltip>
    );
}
